import { useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { useTenantStore } from '../stores/tenantStore';

export function useTenant() {
  const { tenant } = useParams<{ tenant: string }>();
  const { config, isLoading, error, loadConfig } = useTenantStore();

  useEffect(() => {
    if (tenant) {
      loadConfig(tenant);
    }
  }, [tenant, loadConfig]);

  return {
    tenant: tenant || '',
    config,
    isLoading,
    error,
  };
}
